import { Button, Row } from 'antd'
import './InspectionSummary.style.less'
import { inviteReviewerPermissionFN, isEmptyValue } from '@/utils/common'
import { useState } from 'react'
import DrawerDecision from '../DrawerDecision/DrawerDecision'
import DrawerConclusion from '../DrawerConclusion/DrawerConclusion'
import { EditOutlined } from '@ant-design/icons'
import ChatButton from '@/components/ChatButton/ChatButton'
import { eventBus } from '@/utils/eventBus'
import { MITT_EVENT_BUS } from '@/constant/common'
import { get, includes } from 'lodash'
import { InspectionStatus } from '@/constant/qsf'
import InspectionCommentListComponent from '@/components/InspectionCommentListComponent'
import { INSPECTION_TYPE_SUBMIT_FOR_REVIEW } from '@/screens/QSF/Inspection/Inspection.constant'
import { useOverallResultSettingHook } from '@/screens/QSF/Inspection/Inspection.hook'
const { INSPECTION_REPORT_COMMENT } = MITT_EVENT_BUS
const { UNDER_REVIEW, NEEDS_REVISIONS } = InspectionStatus

interface Props {
  data: any
  editable: boolean
  user: any
  dataInspection: any
  extraSource: any
  inspection: any
}
function InspectionSummary(props: Props) {
  const { data, dataInspection, user, extraSource = {}, inspection } = props
  const { inspectionCommentsData, overallResultSettingData } = extraSource
  const overallResults = (overallResultSettingData as any)?.options || []

  const { result: resultMain, decision: decisionMain } = data
  const { result, comment } = resultMain

  const { decision, comment: commentDecision } = decisionMain

  const [modalDecision, setModalDecision] = useState(false)

  const [drawerConclusion, setdrawerConclusion] = useState(false)

  const getInspectionSummaryCounter = get(
    dataInspection,
    'inspection_summary_counter'
  )
  const inspectionRound = get(dataInspection, 'round')
  const summaryRound = get(dataInspection, 'inspection_summary_round')
  const inspectionStatus = get(dataInspection, 'status')
  const isInvitedAsReviewer = inviteReviewerPermissionFN(user, dataInspection)
  const inspectionType = get(dataInspection, 'type', '')
  const inspectionSupportCommentList = includes(
    [INSPECTION_TYPE_SUBMIT_FOR_REVIEW],
    inspectionType
  )

  const onOpenCommentDrawer = (
    section,
    sectionIndex,
    subSection,
    subSectionIndex
  ) => {
    eventBus.emit(INSPECTION_REPORT_COMMENT, {
      selectedSubSection: subSection ? { subSection, subSectionIndex } : null,
      selectedSection: { section, sectionIndex },
    })
  }

  const renderCommentsSummary = () => {
    let result = null

    if (includes([UNDER_REVIEW, NEEDS_REVISIONS], inspectionStatus)) {
      if (isInvitedAsReviewer) {
        result = (
          <ChatButton
            isHidden={extraSource?.generatingReportAtom?.isGenerating}
            redPoint={inspectionRound === summaryRound}
            chatCount={getInspectionSummaryCounter}
            onClick={() => {
              const section = {
                id: dataInspection?.id,
                title: 'Inspection Summary',
                type: 'inspection_summary',
              }
              const sectionIndex = 0
              onOpenCommentDrawer(section, sectionIndex, null, null)
            }}
          />
        )
      }
    }

    return result
  }

  const templateOverallResult = inspection?.template?.option?.overall_result

  const colorResult = (val) => {
    const lowerVal = val?.toLowerCase()

    const fromSystem = overallResults?.find(
      (opt) => opt.name === lowerVal || opt.value?.toLowerCase() === lowerVal
    )
    if (fromSystem) return fromSystem.color

    const customOptions = templateOverallResult?.custom?.options || []
    const fromTemplate = customOptions.find(
      (opt) => opt.name === lowerVal || opt.value?.toLowerCase() === lowerVal
    )
    if (fromTemplate) return fromTemplate.color

    return val == 'PASS'
      ? '#65bf73'
      : val == 'FAIL'
      ? '#C03261'
      : val == 'PENDING' || val == 'CIO'
      ? '#EF9747'
      : '#848484'
  }

  return (
    <div
      className="inspection-summary-container"
      id="inspection-summary-container"
    >
      <div className="title">
        <p>Inspection Summary</p>
        <div style={{ marginLeft: 10 }}>{renderCommentsSummary()}</div>
      </div>

      <div className="data-container">
        <div className="section">
          <Row align={'middle'}>
            <Row align={'middle'}>
              <p className="label">Overall Conclusion:</p>
              <p
                className="data"
                style={{
                  color: colorResult(result),
                  fontSize: 20,
                  fontWeight: 700,
                }}
              >
                {!isEmptyValue(result) ? result : '-'}
              </p>
            </Row>
            {props.editable && (
              <Button
                className="edit-button"
                onClick={() => setdrawerConclusion(true)}
                icon={<EditOutlined />}
              />
            )}
          </Row>
          <p className="comment">{!isEmptyValue(comment) ? comment : '-'}</p>
        </div>
        <div className="section">
          <Row align={'middle'}>
            <Row align={'middle'}>
              <p className="label">Decision:</p>
              <p className="data"> {decision ?? '-'}</p>
            </Row>
            {props.editable && (
              <Button
                className="edit-button"
                onClick={() => setModalDecision(true)}
                icon={<EditOutlined />}
              />
            )}
          </Row>
          <p className="comment">
            {!isEmptyValue(commentDecision) ? commentDecision : '-'}
          </p>
        </div>
      </div>
      {inspectionSupportCommentList && (
        <div className="comment-report-container">
          <InspectionCommentListComponent dataSource={inspectionCommentsData} />
        </div>
      )}

      {drawerConclusion && (
        <DrawerConclusion
          dataInspection={inspection}
          data={data?.result}
          index={null}
          open={drawerConclusion}
          onClose={() => setdrawerConclusion(false)}
        />
      )}

      {modalDecision && (
        <DrawerDecision
          data={data?.decision}
          index={null}
          open={modalDecision}
          onClose={() => setModalDecision(false)}
        />
      )}
    </div>
  )
}

export default InspectionSummary
